
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 33c-4.74 0-8.578-3.67-8.931-8.32l-6.557-5.066c-.861 1.081-1.655 2.224-2.295 3.474-.29.574-.29 1.25 0 1.825C9.607 31.526 16.317 36 24 36c1.682 0 3.304-.25 4.868-.654l-3.243-2.51A9.008 9.008 0 0124 33zm19.614 3.631l-6.91-5.34a20.703 20.703 0 005.078-6.38 2.02 2.02 0 000-1.824C38.393 16.474 31.683 12 24 12a19.26 19.26 0 00-9.207 2.356L6.84 8.211a1 1 0 00-1.404.175L4.21 9.966a1 1 0 00.175 1.403l36.773 28.42a1 1 0 001.404-.175l1.227-1.58a1 1 0 00-.176-1.403zM32.13 27.756l-2.456-1.898a5.922 5.922 0 00-7.257-7.621c.377.51.58 1.128.582 1.763a3.01 3.01 0 01-.096.625l-4.6-3.556A8.894 8.894 0 0124 15a8.995 8.995 0 019 9c0 1.352-.33 2.612-.869 3.757z","fill":"#535353"}})])
          )
        }
      }
    